<template>
  <div>
    <div class="d-flex">
      <div>
        <el-image
          :src="formData.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            formData.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width: 234px; height: 154px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 234px; height: 154px"
            />
          </div>
        </el-image>
        <div class="d-flex">
          <el-button
            plain
            size="small"
            style="width: 100%;"
            @click="uploadImage"
          >
            {{ $l("btn_uploadImage") || "上传图片" }}
          </el-button>
        </div>
      </div>

      <div style="flex: 1;" class="pl-3">
        <div>
          <el-form
            ref="form"
            :model="formData"
            :rules="rules"
            label-position="top"
            size="mini"
          >
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_fabricColorTitle') || '面料中文颜色'"
                  prop="fabricColorTitle"
                >
                  <el-input
                    v-model="formData.fabricColorTitle"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    maxlength="100"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_fabricColorTitleEn') || '面料英文颜色'"
                  prop="fabricColorTitleEn"
                >
                  <el-input
                    v-model="formData.fabricColorTitleEn"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    maxlength="100"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_request_quantity') || '需求数量'"
                  prop="requestQuantity"
                >
                  <el-input-number
                    v-model="formData.requestQuantity"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    :min="0"
                    :precision="2"
                    :controls="false"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('form_label_isCustomerExclusiveColor') ||
                      '是否客户专属颜色'
                  "
                  prop="isCustomerExclusiveColor"
                >
                  <el-select
                    v-model="formData.isCustomerExclusiveColor"
                    :placeholder="
                      $l('INDEX.tips_select_placeholder') || '请选择...'
                    "
                    clearable
                    style="width: 100%"
                  >
                    <el-option
                      :label="$l('INDEX.option_no') || '否'"
                      value="N"
                    />
                    <el-option
                      :label="$l('INDEX.option_yes') || '是'"
                      value="Y"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l("INDEX.tips_question_save") || "是否要保存更改" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l("INDEX.btn_cancel") || "取消" }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l("INDEX.btn_no_save") || "不保存" }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l("INDEX.btn_save") || "保存" }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { VXETable } from "vxe-table";
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [EditLoading],
  props: {
    row: { type: Object, default: () => ({}) },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {
        defaultImageCode: "",
        defaultImageUrl: "",
        defaultImageSpec: "",
        isCustomerExclusiveColor: "N",
      },
      rules: {
        fabricColorTitle: [
          {
            required: true,
            message: this.$l("INDEX.tips_input_placeholder") || "请输入...",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(
                  new Error(
                    this.$l("INDEX.tips_input_placeholder") || "请输入..."
                  )
                );
              }

              let items = this.tableData;

              const itemIndex = this.row?.itemIndex || -1;
              if (itemIndex >= 0) {
                items = items.filter((item) => item.itemIndex !== itemIndex);
              }

              // 校验颜色是否重复
              const isRepdeat = items.some(
                (row) => row.fabricColorTitle === value
              );
              if (isRepdeat) {
                return callback(
                  new Error(this.$l("tips_fabricColorTitle_repeat"))
                );
              }
              callback();
            },
          },
        ],
        fabricColorTitleEn: [
          {
            required: true,
            message: this.$l("INDEX.tips_input_placeholder") || "请输入...",
            trigger: "blur",
          },
        ],
        requestQuantity: [
          {
            required: true,
            message: this.$l("INDEX.tips_input_placeholder") || "请输入...",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(
                  new Error(this.$l("INDEX.tips_input_cannot_be_zero"))
                );
              }
              callback();
            },
          },
        ],
        isCustomerExclusiveColor: [
          {
            required: true,
            message: this.$l("INDEX.tips_select_placeholder") || "请选择...",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.formData = { ...this.formData, ...this.row };
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return (this.backDialogVisible = false);

      // 转换 isCustomerExclusiveColor 为对应的文本
      const isCustomerExclusiveColorText =
        this.formData.isCustomerExclusiveColor === "Y" ? "是" : "否";

      this.$emit("success", {
        ...this.formData,
        isCustomerExclusiveColorText,
      });
      this.close();
    },
    async uploadImage() {
      const { file } = await VXETable.readFile({
        types: ["jpeg", "JPEG", "jpg", "JPG", "png", "PNG", "gif", "GIF"],
      }).catch(() => ({}));
      if (!file) return;

      if (this.loadingOpen()) return;
      const res = await this.$api
        .SYS_UPLOAD(file)
        .then((res) => ({
          defaultImageCode: res.body.fileId,
          defaultImageUrl: res.body.url,
          defaultImageSpec: file.type,
        }))
        .catch(() => null);
      this.loadingClose();
      if (!res) {
        this.$message.error(
          this.$l("INDEX.uploader_label_status_error") || "上传失败"
        );
        this.loadingClose();
        return;
      }

      this.formData.defaultImageCode = res.defaultImageCode;
      this.formData.defaultImageUrl = res.defaultImageUrl;
      this.formData.defaultImageSpec = res.defaultImageSpec;
    },
    cancel() {
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-input__inner {
    text-align: start;
  }
}
</style>
